import logging from './logging'

const archive = {
  logging,
}

export default archive
